"use client"

import { useState, useEffect, useCallback } from "react"
import { api } from "../services/api"

export const useMoveData = (id) => {
  const [moveData, setMoveData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")

  const fetchMoveData = useCallback(async () => {
    if (!id) return

    setIsLoading(true)
    setError("")

    try {
      const response = await api.getMoveById(id)
      const data = response.data || response
      setMoveData(data)
    } catch (err) {
      console.error("Erreur lors du chargement:", err)
      setError(err.message || "Une erreur est survenue lors du chargement des données")
    } finally {
      setIsLoading(false)
    }
  }, [id])

  useEffect(() => {
    fetchMoveData()
  }, [fetchMoveData])

  const refetch = useCallback(() => {
    fetchMoveData()
  }, [fetchMoveData])

  return { moveData, isLoading, error, refetch }
}
